export default __webpack_public_path__ + "static/media/no-discussion-dark.e60c8a04.svg";